module.exports = __webpack_public_path__ + "static/img/p1.542ba191.png";